/* tslint:disable */
// This file was automatically generated and should not be edited.
/* tslint:disable */
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
export var Categories;
(function (Categories) {
    Categories["Business"] = "Business";
    Categories["Entertainment"] = "Entertainment";
    Categories["Politics"] = "Politics";
    Categories["Sport"] = "Sport";
    Categories["Technology"] = "Technology";
})(Categories || (Categories = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
//# sourceMappingURL=schemaTypes.js.map


//////////////////
// WEBPACK FOOTER
// ../controller/dist/schemaTypes.js
// module id = 1311
// module chunks = 0